/**
 * Cibles (`environment.target`) où le service worker doit être enregistré.
 *
 * Déploiement progressif : **intégration uniquement** pour l'instant, le temps
 * de valider la PWA en conditions réelles (notamment OAuth en mode standalone iOS).
 * Pour activer la production plus tard, ajouter `'production'` à cette liste.
 */
export const PWA_ENABLED_TARGETS = ['integration'];

/** Délai au terme duquel le service worker est enregistré si l'application n'est pas stabilisée. */
export const SW_REGISTER_WHEN_STABLE_MS = 30_000;

/** Valeur de `registrationStrategy` passée à `ServiceWorkerModule.register`. */
export const SW_REGISTRATION_STRATEGY = `registerWhenStable:${SW_REGISTER_WHEN_STABLE_MS}`;

/** Indique si le service worker doit être enregistré pour la cible donnée. */
export function serviceWorkerEnabled(target: unknown): boolean {
  return typeof target === 'string' && PWA_ENABLED_TARGETS.includes(target);
}
